import CallAdaptiveButton from 'flow/components/CallAdaptiveButton';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectExtensionKeyFromContactKey,
    selectOwnExtensionKey,
} from 'flow/selectors/ExtensionSelectors';
import {
    selectCallRecordContactKey,
    selectCallRecordPhoneNumber,
} from 'flow/selectors/call-records-selectors';
import { CallRecordKey } from 'flow/types/EntityKeys';

interface Props {
    callRecordKey: CallRecordKey;
    size?: 'small' | 'medium' | 'large';
    activeBg?: boolean;
}

const CallRecordCallButton = ({
    callRecordKey,
    size = 'medium',
    activeBg,
}: Props) => {
    const phoneNumber = useAppSelector((state) =>
        selectCallRecordPhoneNumber(state, callRecordKey),
    );
    const contactKey = useAppSelector((state) =>
        selectCallRecordContactKey(state, callRecordKey),
    );

    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const extensionKey = useAppSelector((state) =>
        contactKey
            ? selectExtensionKeyFromContactKey(state, contactKey)
            : undefined,
    );

    const isHidden =
        !phoneNumber ||
        phoneNumber === 'unknown' ||
        phoneNumber === 'anonymous' ||
        extensionKey === ownExtensionKey;

    if (isHidden) return null;

    return (
        <CallAdaptiveButton
            phoneNumber={phoneNumber}
            extensionKey={extensionKey}
            size={size}
            activeBg={activeBg}
        />
    );
};

export default CallRecordCallButton;
